/* RESPONSIBLE TEAM: team-automation-foundations */
import type AppService from 'embercom/services/app-service';
import { fragment } from 'ember-data-model-fragments/attributes';
import { buildValidations, validator } from 'ember-cp-validations';
import Step from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { inject as service } from '@ember/service';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';
import { type AllChannels } from 'embercom/lib/operator/custom-bots/constants';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';

const Validations = buildValidations({
  action: [
    validator('presence', true),
    validator('rule-action-is-valid', {
      message: 'operator.workflows.visual-builder.validations.empty-action-error',
    }),
  ],
});

export default class AssignConversation extends Step.extend(Validations) {
  @service declare appService: AppService;

  @fragment('rules/rule-action') declare action: any;

  get supportedChannels(): Readonly<AllChannels[]> {
    return SUPPORTED_CHANNELS.assignConversation;
  }

  static get supportedContexts() {
    return [
      TargetContext.Conversation,
      TargetContext.CustomerTicket,
      TargetContext.BackOfficeTicket,
      TargetContext.TrackerTicket,
    ];
  }

  static get requiredBillingFeature() {
    return 'workflows_core_billing_feature';
  }

  static createNewStep(store: Store): AssignConversation {
    return store.createRecord('operator/visual-builder/step/assign-conversation', {
      action: store.createFragment('rules/rule-action', {
        type: 'assign-conversation',
        justAdded: true,
        actionData: {},
      }),
      type: 'operator/visual-builder/step/assign-conversation',
    });
  }
}
